import React from 'react';
import PropTypes from 'prop-types';

import FilterNumberPair from 'components/search_sidebar/filter_number_pair';

export default class MultifamilyFilters extends React.Component {

  static propTypes = {
    filterKeyMappings: PropTypes.object.isRequired,
    filterLabelMappings: PropTypes.object.isRequired,
    multifamilyFilter: PropTypes.object.isRequired,
    onMultifamilyFilterChange: PropTypes.func.isRequired
  };

  handleChange = (e, name) => {
    this.props.onMultifamilyFilterChange(e, name);
  }

  render() {
    const {
      filterKeyMappings,
      filterLabelMappings,
      multifamilyFilter,
    } = this.props;

    return (
      <React.Fragment>
        <div className="multifamily-information">
          <div className="row left-buffer-sm right-buffer-sm">
            <div className="col-md-9 pl-0">
              <FilterNumberPair
                filter={multifamilyFilter}
                label={filterLabelMappings['beds']}
                name="beds"
                valueKeys={filterKeyMappings['beds']}
                onChange={this.handleChange}
              />
            </div>
          </div>
          <div className="row left-buffer-sm right-buffer-sm">
            <div className="col-md-9 pl-0">
              <FilterNumberPair
                filter={multifamilyFilter}
                label={filterLabelMappings['baths']}
                name="baths"
                valueKeys={filterKeyMappings['baths']}
                onChange={this.handleChange}
              />
            </div>
          </div>
          <div className="row left-buffer-sm right-buffer-sm">
            <div className="col-md-9 pl-0">
              <FilterNumberPair
                filter={multifamilyFilter}
                label={filterLabelMappings['size']}
                name="size"
                valueKeys={filterKeyMappings['size']}
                onChange={this.handleChange}
              />
            </div>
          </div>
        </div>
        <div className="multifamily-information">
          <div className="row left-buffer-sm right-buffer-sm">
            <div className="col-md-9 pl-0">
              <FilterNumberPair
                filter={multifamilyFilter}
                label={filterLabelMappings['rent']}
                name="rent"
                valueKeys={filterKeyMappings['rent']}
                onChange={this.handleChange}
              />
            </div>
          </div>
          <div className="row left-buffer-sm right-buffer-sm">
            <div className="col-md-9 pl-0">
              <FilterNumberPair
                filter={multifamilyFilter}
                label={filterLabelMappings['marketRent']}
                name="marketRent"
                valueKeys={filterKeyMappings['marketRent']}
                onChange={this.handleChange}
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
